import type { ReactNode } from 'react';
import type { TabId } from './useAquariumFormTabs';

interface AquariumFormTabPanelProps {
  id: TabId;
  activeTab: TabId;
  children: ReactNode;
}

/**
 * Tab panel wrapper.
 *
 * Always mounts children (no conditional rendering) — the `hidden` attribute
 * hides the panel visually and from assistive technology while keeping the
 * DOM nodes alive. This is required so form field registrations are preserved
 * when switching tabs.
 */
export function AquariumFormTabPanel({ id, activeTab, children }: AquariumFormTabPanelProps) {
  const isActive = id === activeTab;

  return (
    <div
      role="tabpanel"
      id={`aq-tabpanel-${id}`}
      aria-labelledby={`aq-tab-${id}`}
      className="rg-aquarium-form__tabpanel"
      hidden={!isActive}
    >
      {children}
    </div>
  );
}
